import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import { Tooltip } from "@toddle-edu/ds-web";

import ConditionalWrapper from "Utils/ConditionalWrapper";

/*
  This is a custom component that wraps a child element in a Tooltip component
  only if the child element is too long to fit in its container.
*/
const ConditionalTooltip = props => {
  const { children } = props;
  const labelRef = useRef(null);
  const [isLabelTooLong, setIsLabelTooLong] = useState(false);

  useEffect(() => {
    if (_.isNil(labelRef.current)) return;

    if (labelRef.current.scrollHeight > labelRef.current.clientHeight)
      setIsLabelTooLong(true);
  }, [labelRef]);

  const labelElement = React.cloneElement(children, { ref: labelRef });

  return (
    <ConditionalWrapper
      condition={isLabelTooLong}
      wrapper={<Tooltip {...props} />}
      type={"wrapperAsElement"}
    >
      {labelElement}
    </ConditionalWrapper>
  );
};
ConditionalTooltip.dispalayName = "ConditionalTooltip";

export default ConditionalTooltip;
